/**
 * The keys/anchor url values for the campaign details page
 */
export const CAMPAIGN_DETAILS_V2_MENU_ITEMS = {
    GET_STARTED: 'get-started',
    SUMMARY: 'summary',
    AUDIENCE: 'audience',
    MESSAGING: 'messaging',
    INMAIL_MESSAGING: 'inmail-messaging',
    QUICK_RESPONSES: 'quick-responses',
    CAMPAIGN_STRATEGY: 'campaign-strategy',
    SETTINGS: 'settings',
};
